// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui' // Element UI
import 'element-ui/lib/theme-chalk/index.css' // Element UI
import App from './App'
import router from './router'

// 引入全局函数和过滤器
import globalFilter from './components/toolkits/globalFilter.js'
import server from './components/toolkits/server'
import cookie from './components/toolkits/cookie'
import jsHelper from './components/toolkits/jsHelper'
import dateHepler from './components/toolkits/dateHelper'
import regExpHelper from './components/toolkits/regExpHelper'
// 全局变量
import global_ from './components/Global'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面

// 富文本
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.use(ElementUI) // Element UI

// 全局函数
Vue.prototype.SERVER = server // server 全局操作，this.SERVER.func 使用
Vue.prototype.COOKIE = cookie // cookie 全局操作，this.COOKIE.func 使用
Vue.prototype.JSHELPER = jsHelper // jsHelper 全局操作，this.JSHELPER.func 使用
Vue.prototype.DATEHELPER = dateHepler // dateHepler 全局操作，this.DATEHELPER.func 使用
Vue.prototype.REGEXPHELPER = regExpHelper // regExpHelper 全局操作，this.REGEXPHELPER.func 使用

// 配置全局过滤器
Object.keys(globalFilter).forEach(key => {
  Vue.filter(key, globalFilter[key])
})
// 防止el-button重复点击
Vue.directive('preventReClick', {
	inserted(el, binding) {
   	  el.addEventListener('click', () => {
     	if (!el.disabled) {
      	 el.disabled = true;
      	 el.style.cursur='not-allowed'
      	 setTimeout(() => {
        	 el.disabled = false
        	 el.style.cursor ='pointer'
       	}, binding.value || 2000)
     	}
   	})
	 }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // components: { App },
  // template: '<App/>',
  render: h => h(App) // Element UI
})




// WEBPACK FOOTER //
// ./src/main.js